import { Navigate, useLocation } from "react-router-dom";
import { pickDefaultLocale, stripLocaleFromPath } from "@/i18n/locale-utils";

/**
 * Top-level redirect: any bare path (e.g. /pricing) → /{preferredLocale}/pricing.
 * Used as the element for unprefixed routes so we land users on a locale URL.
 */
export function LocaleRedirect() {
  const location = useLocation();
  const { locale, rest } = stripLocaleFromPath(location.pathname);
  // Already locale-prefixed? Just render Navigate to same path (shouldn't happen but defensive).
  if (locale) return <Navigate to={`${location.pathname}${location.search}${location.hash}`} replace />;
  const target = `/${pickDefaultLocale()}${rest === "/" ? "" : rest}${location.search}${location.hash}` || `/${pickDefaultLocale()}`;
  return <Navigate to={target} replace />;
}
